<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="data"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="employeeTaskVerificationForm"
          :redirect-detail="false"
          :show-add-button="true"
          caption="<i class='fa fa-align-justify'></i> Verifikasi Pekerjaan Karyawan Listing"
          addButton="Tambah Verifikasi Pekerjaan Karyawan"
          @editForm="editForm"
          @resetForm="resetForm"
        ></global-table>

        <b-modal
          ref="myModalRef"
          id="addModals"
          header-border-variant="no-border text-center"
          footer-border-variant="no-border"
          footer-bg-variant="light"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          size="lg"
        >
          <div slot="modal-header" class="text-center">
            <h3 class="text-center" v-if="!isEdit">Input Verifikasi Karyawan Baru</h3>
            <h3 class="text-center" v-else-if="isEdit">Ubah Verifikasi Karyawan</h3>
          </div>

          <b-form id="employeeTaskVerificationForm" validated novalidate>
            <b-row>
              <b-col sm="4">
                <b-form-group label-for="title" label="Title">
                  <b-form-input
                    id="title"
                    type="text"
                    v-model="$v.employeeTaskVerificationForm.title.$model"
                    :state="!$v.employeeTaskVerificationForm.title.$invalid"
                    required
                    placeholder="Title working"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    >Title harus di isi.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group label-for="subtitle" label="Sub Title">
                  <b-form-input
                    id="subtitle"
                    type="text"
                    v-model="$v.employeeTaskVerificationForm.subtitle.$model"
                    :state="!$v.employeeTaskVerificationForm.subtitle.$invalid"
                    required
                    placeholder="Subtitle working"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    >Subtitle harus di isi.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col sm="4">
                  <b-form-group label-for="date_show_task" label="Tanggal Muncul Di Applikasi">
                    <v-date-picker
                      id="date_show_task"
                      :input-props="{ class: 'form-control', placeholder: 'Tanggal Muncul Di Applikasi', required: ''}"
                      :state="!$v.employeeTaskVerificationForm.date_show_task.$invalid"
                      v-model="$v.employeeTaskVerificationForm.date_show_task.$model"
                    ></v-date-picker>
                    <div
                      v-if="$v.employeeTaskVerificationForm.date_show_task.$invalid"
                      class="invalid-feedback-custom"
                    >Tanggal muncul harus di isi.</div>
                  </b-form-group>
                </b-col>
            </b-row>

            <b-row>
              <b-col sm="6">
                <b-form-group label-for="employee_id" label="Nama Karyawan">
                  <template v-if="!isEdit">
                    <multi-select
                      id="employee_id"
                      :options="listEmployee"
                      :selected-options="listEmployeePick"
                      v-model="$v.employeeTaskVerificationForm.employee_id.$model"
                      :isError="$v.employeeTaskVerificationForm.employee_id.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                      @select="onSelectEmployee"

                    ></multi-select>
                    <div
                      v-if="employeeTaskVerificationForm.employee_id === null"
                      class="invalid-feedback-custom"
                    >
                      Tugas untuk karyawan harus di isi.
                    </div>
                  </template>

                   <template v-else>
                    <model-select
                      id="employee_id"
                      :options="listEmployee"
                      v-model="$v.employeeTaskVerificationForm.employee_id.$model"
                      :isError="$v.employeeTaskVerificationForm.employee_id.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="employeeTaskVerificationForm.employee_id === null"
                      class="invalid-feedback-custom"
                    >
                      Tugas untuk karyawan harus di isi.
                    </div>
                  </template>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group label-for="template_id" label="Template Verifikasi">
                  <model-select
                    id="template_id"
                    :options="listTemplate"
                    v-model="$v.employeeTaskVerificationForm.template_id.$model"
                    :isError="$v.employeeTaskVerificationForm.template_id.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="employeeTaskVerificationForm.template_id === null"
                    class="invalid-feedback-custom"
                  >
                    Template Verifikasi harus di isi.
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
          
          </b-form>

          <div slot="modal-footer" class="float-right">
            <b-button
              type="button"
              size="sm"
              variant="danger"
              @click="cancelAdd"
            >
              <i class="fa fa-undo"></i> Back </b-button
            >&nbsp;
            <b-button
              v-if="employeeTaskVerificationForm.status === '0' || employeeTaskVerificationForm.status === null"
              type="button"
              size="sm"
              variant="primary"
              @click="saveProcess"
              :disabled="$v.employeeTaskVerificationForm.$invalid"
            >
              <i class="fa fa-save"></i> Save
            </b-button>
          </div>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import masterInterfaces from "@/templates/_master_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect, MultiSelect } from "vue-search-select";
import { VueEditor, Quill } from "vue2-editor";

export default {
  name: "verification-template",
  components: { globalTable, ModelSelect, MultiSelect, VueEditor, Quill },
  props: {
    tableDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: [],
      loading: true,
      listEmployee: [],
      listTemplate: [],
      listEmployeePick: [],
      listStatus: [
        {'value': '1', 'text': 'Show'},
        {'value': '2', 'text': 'Hide'}
      ],
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
      fields: [
        { key: "title", label: "Title", sortable: true },
        { key: "subtitle", label: "Subtitle", sortable: true },
        { key: "employee_name", label: "Karyawan" },
        { key: "status_label", label: "Status" },
        { key: "updated_time", label: "Tanggal Update" },
        { key: "action", class: "text-center width-80" },
      ],
      employeeTaskVerificationForm: masterInterfaces.employee_task_verification,
      isEdit: false,
    };
  },
  validations: {
    employeeTaskVerificationForm: {
      title: { required },
      subtitle: { required },
      employee_id: { required },  
      customer_id: { },  
      date_show_task: { required },  
      template_id: { required },  
      freezer_request_code: { },
      category: { },
      date_inserted: { },
      updated_time: { },
      status: { }
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.getVerificationEmployeeList();
      this.getDropdown();
    },
    onSelectEmployee: function(items, lastSelectItem) {
      this.listEmployeePick = items;
      this.employeeTaskVerificationForm.employee_id = items;
    },
    getVerificationEmployeeList: function () {
      this.axios
        .get("web/verification-task/employee/")
        .then((response) => {
          this.data = response.data.data;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdown: function() {
      this.axios
        .get("web/dropdown/dropdown-task-verification/2")
        .then(response => {
          this.listEmployee = response.data.employee;
          this.listTemplate = response.data.template;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    editForm: function (e) {
      this.isEdit = true;
      this.listEmployeePick = [];
      this.employeeTaskVerificationForm = e;
      this.employeeTaskVerificationForm.date_show_task = new Date(e.date_show_task);
      console.log(e);
    },
    resetForm: function () {
      for (var a in masterInterfaces.employee_task_verification) {
        masterInterfaces.employee_task_verification[a] = null;
      }
      this.employeeTaskVerificationForm = masterInterfaces.employee_task_verification;
    },
    cancelAdd: function () {
      this.isEdit = false;
      this.$refs.myModalRef.hide();
      this.init();
    },
    saveProcess: function (evt) {
      evt.preventDefault();
      this.employeeTaskVerificationForm.category = 2;
      if (this.isEdit) {
        if (confirm("Apakah anda ingin mengubah template ini?")) {
          this.axios
            .put(
              "web/verification-task/employee/edit/",
              this.employeeTaskVerificationForm
            )
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Ubah Template Berhasil",
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.expired(error, "Ubah Template");
            })
            .finally(() => {
              this.cancelAdd();
              this.init();
            });
        }
      } else {
        if (confirm("Apakah anda ingin menambahkan template ini?")) {
          console.log(this.employeeTaskVerificationForm);
          this.axios
            .post(
              "web/verification-task/employee/add/",
              this.employeeTaskVerificationForm
            )
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Tambah Template Berhasil",
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: "Tambah Template Gagal",
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.expired(error, "Tambah Template");
            })
            .finally(() => {
              this.cancelAdd();
              this.init();
            });
        }
      }
    },
    expired: function (error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

  